/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Section_ImportsInputs */

const cs_integrations_section_imports = /** @type {(inputs: Integrations_Section_ImportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importy`)
};

const en_integrations_section_imports = /** @type {(inputs: Integrations_Section_ImportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imports`)
};

/**
* | output |
* | --- |
* | "Imports" |
*
* @param {Integrations_Section_ImportsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_section_imports = /** @type {((inputs?: Integrations_Section_ImportsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Section_ImportsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_section_imports(inputs)
	return cs_integrations_section_imports(inputs)
});